import { PmContract } from '@/DTOS/PmContract/Response/PmContract';
import { Divider, Drawer, Table, Tag } from 'antd';
import moment from 'moment';
import React from 'react';
import { Column } from '../../utils/column';

interface Props {
  handleModalInformationClose: () => void;
  modalInformation: boolean;
  selectedRecord: PmContract | null;
}

const PmContractInformation: React.FC<Props> = ({ handleModalInformationClose, modalInformation, selectedRecord }) => {
  const isSmallScreen = window.innerWidth <= 720;
  const intervalColumns: Column[] = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'PmOffer Id',
      dataIndex: 'pmOfferId',
      key: 'pmOfferId',
      hidden: true,
    },
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
    },
  ];

  const deviceColumns: Column[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'Denumire',
      dataIndex: ['device', 'name'],
      key: 'deviceName',
      render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
      title: 'Model',
      dataIndex: ['device', 'model'],
      key: 'model',
    },
    {
      title: 'Bucati',
      dataIndex: 'piece',
      key: 'piece',
    },
    {
      title: 'Pret/Device',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Pret Total',
      dataIndex: '',
      key: 'total',
      render: (record: any) => record.piece * record.price,
    },
    {
      title: 'Persoana Contact',
      dataIndex: ['pmContractWorkPlaceMetadata', 'agent', 'name'],
      key: 'contactPerson',
    },
    {
      title: 'Locatia',
      dataIndex: ['pmContractWorkPlaceMetadata', 'workPlace', 'name'],
      key: 'location',
    },
  ];

  const laborExtracolumns: Column[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'Labor Extra Name',
      dataIndex: ['laborExtra', 'name'],
      key: 'laborExtraName',
      render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
      title: 'Bucati',
      dataIndex: 'piece',
      key: 'piece',
    },
    {
      title: 'Pret',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Pret Total',
      dataIndex: '',
      key: 'total',
      render: (record: any) => record.piece * record.price,
    },
    {
      title: 'Unit Measure',
      dataIndex: 'unitMeasure',
      key: 'unitMeasure',
    },
  ];

  return (
    <Drawer
      title={`Informatii suplimentare`}
      placement={'right'}
      onClose={handleModalInformationClose}
      open={modalInformation}
      width={isSmallScreen ? '100%' : '50%'}
      key={'drawer_right'}
    >
      <h2>Contract Nr. {selectedRecord?.number}</h2>
      <Tag color='purple' style={{ fontSize: 15 }}>
        {selectedRecord?.enumPmContractStatus?.name}
      </Tag>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Client:</span>{' '}
        {selectedRecord?.metadata?.company?.name ?? selectedRecord?.company?.name}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Data:</span> {moment(selectedRecord?.date).format('DD.MM.YYYY')}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Data Interval:</span>{' '}
        {moment(selectedRecord?.dateStart).format('DD.MM.YYYY')} -{' '}
        {moment(selectedRecord?.dateEnd).format('DD.MM.YYYY')}
      </p>

      <Divider />

      <h2>Intervale</h2>
      <Table
        bordered
        pagination={false}
        columns={intervalColumns}
        dataSource={selectedRecord?.pmContractIntervals || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />

      <h2>Device</h2>
      <Table
        bordered
        pagination={false}
        columns={deviceColumns}
        dataSource={selectedRecord?.pmContractWorkPlaceItems || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />

      <h2>Manopera</h2>
      <Table
        bordered
        pagination={false}
        columns={laborExtracolumns}
        dataSource={selectedRecord?.pmContractLaborExtras || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />
    </Drawer>
  );
};

export default PmContractInformation;
